module.exports = __webpack_public_path__ + "static/media/tubuli_tn.b3ee5ebb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/tubuli_tn.jpg
// module id = 688
// module chunks = 0